var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRestricted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icRestricted") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Manage-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manage-photos---Both-Alerts",
    transform: "translate(-659.000000, -551.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(470.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Restricte-title",
    transform: "translate(189.000000, 433.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icRestricted",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#1F83DD",
    cx: 8.5,
    cy: 8.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4073034,13 L10.6882022,13 L9.53792135,10.0042135 C9.43679725,9.72612221 9.28089993,9.53230392 9.07022472,9.42275281 C8.85954951,9.3132017 8.58567584,9.25842697 8.24859551,9.25842697 L6.61797753,9.25842697 L6.61797753,13 L5,13 L5,4 L8.85533708,4 C9.8750051,4 10.6502782,4.22331237 11.1811798,4.66994382 C11.7120813,5.11657527 11.9775281,5.7570183 11.9775281,6.59129213 C11.9775281,7.18960973 11.8195241,7.69732938 11.5035112,8.11446629 C11.1874984,8.53160321 10.738767,8.8286508 10.1573034,9.00561798 C10.6882049,9.11516909 11.071628,9.4859519 11.3075843,10.1179775 L12.4073034,13 Z M8.62780899,7.99438202 C9.2429806,7.99438202 9.69803223,7.88061912 9.99297753,7.65308989 C10.2879228,7.42556066 10.4353933,7.0800585 10.4353933,6.61657303 C10.4353933,6.16151458 10.2900295,5.82233258 9.99929775,5.59901685 C9.70856596,5.37570113 9.25140761,5.26404494 8.62780899,5.26404494 L6.59269663,5.26404494 L6.59269663,7.99438202 L8.62780899,7.99438202 Z",
    id: "R",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRestricted);
export default __webpack_public_path__ + "static/media/icRestricted.62dd167da6bf0dc6fd428b3a6dbbaf60.svg";
export { ForwardRef as ReactComponent };